export const TRUNCATION_THRESHOLD = 200;

export function toDisplayValue(raw, isComplexKey) {
  const isUnexpectedShape = !isComplexKey && raw !== null && typeof raw === 'object';
  const value = isUnexpectedShape ? JSON.stringify(sortKeysDeep(raw)) : raw;
  const measured = typeof value === 'string' ? value : JSON.stringify(value);
  return { value, truncated: measured.length > TRUNCATION_THRESHOLD };
}

export function sortKeysDeep(value) {
  if (Array.isArray(value)) return value.map(sortKeysDeep);
  if (value !== null && typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((acc, k) => ({ ...acc, [k]: sortKeysDeep(value[k]) }), {});
  }
  return value;
}
